// utils/Collapse.jsx
import React, { useRef, useEffect, useState } from 'react';

export default function Collapse({ isOpen, duration = 300, children }) {
  const innerRef = useRef(null);
  const [height, setHeight] = useState(0);

  // recalcule la hauteur quand on ouvre/ferme ou quand le contenu change
  useEffect(() => {
    if (isOpen) {
      const h = innerRef.current ? innerRef.current.scrollHeight : 0;
      setHeight(h);
    } else {
      setHeight(0);
    }
  }, [isOpen, children]);

  // (optionnel) ajuste sur resize
  useEffect(() => {
    if (!innerRef.current) return;
    const ro = new ResizeObserver(() => {
      if (isOpen) setHeight(innerRef.current.scrollHeight);
    });
    ro.observe(innerRef.current);
    return () => ro.disconnect();
  }, [isOpen]);

  return (
    <div
      style={{
        height,
        overflow: 'hidden',
        transition: `height ${duration}ms ease`,
      }}
      aria-hidden={!isOpen}
    >
      <div ref={innerRef}>{children}</div>
    </div>
  );
}

